module.exports = __webpack_public_path__ + "static/img/ddky_logo_s.4fb61be8.png";